var collapsible_list_pair_rtlignore_default = {
  "container": "_8rLaI",
  "title": "h-Eu0",
  "viewerContainer": "CZ-cV",
  "titleContainer": "VMfSB",
  "content": "twkWE",
  "expandIcon": "s7Hsl",
  "dndIcon": "T8oLJ",
  "RTL": "_0fAZO",
  "LTR": "_936Hu",
  "itemContainer": "BU6Xa",
  "itemContainerViewer": "h0yhE",
  "mouseDown": "LGfhk",
  "innerEditor": "IVTg5",
  "item": "jCeP-",
  "floatingAddPluginMenuWrapper": "gwRoB"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
